import { useEffect, useState } from 'react'

/** Matches the member.css mobile breakpoint (max-width: 980px) so the JSX
 * shell and the stylesheet flip layouts at the same width. */
export const MEMBER_MOBILE_QUERY = '(max-width: 980px)'

const initialMatch = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(MEMBER_MOBILE_QUERY).matches

export const useIsMemberMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(initialMatch)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mediaQuery = window.matchMedia(MEMBER_MOBILE_QUERY)
    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches)
    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }, [])

  return isMobile
}
